module.exports = __webpack_public_path__ + "img/jola_orig.f2893a1d.png";